// extracted by mini-css-extract-plugin
module.exports = {"Calculator":"Calculator_Calculator__zuHLB","Header":"Calculator_Header__u7dIc"};